import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/lib/analytics";

export default function RouteTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => { initAnalytics(); }, []);
  useEffect(() => { trackPageView(pathname + search); }, [pathname, search]);
  return null;
}
